export default {
  maleva: "#0DB8B2",
  cookIt: "#779F7C",
};
